jQuery(function($) {


var l_window = parseInt($(window).width());
var $headser = $('.site-header');



  /**********************************************************************/
/*************** GESTION DU MENU / HOVER SUR PREMIER NIVEAU ****************/
/**********************************************************************/

// $( "#primary-menu > li.menu-item-has-children" ).hover(
//   function() {
//     $headser.addClass('open-submenu');
//   }, function() {
//     $headser.removeClass('open-submenu');
//   }
// );


 $(".menu-toggle").click(function(e){
      if($('.menu-toggle').attr('aria-expanded') == 'true'){
        $('body').addClass('open_menu');
      }else{
         $('body').removeClass('open_menu');
      }
  });  


/**********************************************************************/
/*************** MUSHROOM - HEADER FIXE ****************/
/**********************************************************************/

//  var headerCaro = document.querySelector("header.site-header");


// function isNavVisible(headerCaro) {
//   return (headerCaro.classList.contains('open-s-menu') ? true : false );
// }


// var options = {
//     offset : 70,

//     // scroll tolerance in px before state changes
//  //   tolerance : 0,
//     // or you can specify tolerance individually for up/down scroll
//     tolerance : {
//         up : 5,
//         down : 0
//     },

//   onUnpin: function() {
//     if ( isNavVisible(headerCaro) ) {
//       this.elem.classList.remove(this.classes.unpinned);
//       this.elem.classList.add(this.classes.pinned);
//     }
//     else {
//       this.elem.classList.add(this.classes.unpinned);
//       this.elem.classList.remove(this.classes.pinned);
//     }
//   }
// };

// var headroom  = new Headroom(headerCaro,options);

// // initialise
// headroom.init();




// /**********************************************************************/
// /*************** MENU / SUB MENU ****************/
// /**********************************************************************/
   



$('#primary-menu').addClass('menu--level-1');
$('#primary-menu > li > ul.sub-menu').addClass('menu--level-2');
$('#primary-menu > li > ul.sub-menu > li > ul.sub-menu').addClass('menu--level-3');
$('#primary-menu > li > ul.sub-menu > li > ul.sub-menu > li > ul.sub-menu').addClass('menu--level-4');

$('#primary-menu > li > a').addClass('menu__link--level-1');
$('#primary-menu > li > ul.sub-menu > li > a').addClass('menu__link--level-2');
$('#primary-menu > li > ul.sub-menu > li ul.sub-menu > li > a').addClass('menu__link--level-3');
$('#primary-menu > li > ul.sub-menu > li ul.sub-menu > li > ul.sub-menu > li > a').addClass('menu__link--level-4');

$('#primary-menu li.menu-item-has-children > a').addClass('menu__link--has-children');
$('#primary-menu li.menu-item-has-children > a').attr('data-menu_open', false);




            const TriggerOpenMenu = document.querySelector(".menu-trigger"); /* BTN */
            const MenuContSlider = document.querySelector(".menu-container-slider");
            const Header = document.querySelector(".site-header");
            const Page = document.querySelector("#page");
            let PrevTarget;
            let timerOver;
            const ControlMenu = () => {

                let expanded = TriggerOpenMenu.getAttribute("aria-expanded");
                if(expanded == "false"){
                    OpenMenu();
                    if (window.innerWidth >= 1100) {
                            document.addEventListener("click", (evt) => {
                                let InElement = evt.target.closest(".menu-container-slider");
                                if (!InElement) {
                                    CloseMenuDesktop();
                                }
                            });
                        }
                    TriggerOpenMenu.setAttribute("aria-expanded", "true");

                }else{
                    CloseMenu();
                    TriggerOpenMenu.setAttribute("aria-expanded", "false");
                }

               
            };
            const OpenMenu = () => {
                MenuContSlider.classList.add("open-menu");
                Page.classList.add("open-menu");
            };
            const CloseMenuDesktop = () => {
                if (window.innerWidth >= 1100) {
                    let OpenMenu = document.querySelectorAll("#primary-menu .expand-menu");
                    OpenMenu.forEach((elt) => {
                        elt.classList.remove("expand-menu");
                        elt.dataset.menu_open = "false";
                        Header.classList.remove("desktop-menu-open");
                    });
                }
            };
            const CloseMenu = () => {
                MenuContSlider.classList.remove("open-menu");
                Page.classList.remove("open-menu");
                CloseMenuDesktop();
            };
            const MenuCrpce = () => {
                

                    TriggerOpenMenu.addEventListener("click", ControlMenu);

                    
            };
            let prevTarget;
            const ApplyExpand = (evt) => {

                let Target = evt.target;
                console.log(evt);
                let SubTarget = Target.nextElementSibling;

                let ParentTarget = Target.closest(".menu-item");
                 console.log("CCc"+Target.classList);
                if (Target.classList.contains("menu__link--level-1") && window.innerWidth < 1100) {
                    evt.returnValue = true;
                } else if (Target.classList.contains("menu__link--has-children") && window.matchMedia("(pointer: coarse)").matches) {
                    evt.preventDefault();
                }
                let SameLevelClass = Target.closest('[class*="menu--level-"]').classList;
                let SameLevelTarget = "";
                SameLevelClass.forEach((elt) => {
                    SameLevelTarget += `.${elt}`;
                });
                let OldTargeted = document.querySelectorAll(`${SameLevelTarget} .expand-menu`);
                OldTargeted.forEach((elt) => {
                    if (elt != Target || elt != prevTarget) {
                        elt.classList.remove("expand-menu");
                        if (elt.dataset.menu_open) {
                            elt.dataset.menu_open = "false";
                        }
                    }
                });
               
                if (Target.dataset.menu_open == "false") {
                 
                    Target.classList.add("expand-menu");
                    if (SubTarget) {
                        SubTarget.classList.add("expand-menu");
                    }
                    Target.dataset.menu_open = "true";
                } else {
                  
                    Target.classList.remove("expand-menu");
                    if (SubTarget) {
                        SubTarget.classList.remove("expand-menu");
                    }
                    Target.dataset.menu_open = "false";
                }
               
                if (document.querySelectorAll(".expand-menu").length) {
                    Header.classList.add("desktop-menu-open");
                } else {
                    Header.classList.remove("desktop-menu-open");
                }
                if (window.innerWidth >= 1100) {
                    let SubLevelFirstEntry = Target.closest(".menu-item").querySelectorAll('[class*="menu--level-"]');
                    SubLevelFirstEntry.forEach((elt, index) => {
                        if (index < 4) {
                            let SubLink = elt.querySelector(".menu-item > a");
                            if (SubLink) {
                                let SubLinkList = SubLink.nextElementSibling;
                                SubLink.classList.add("expand-menu");
                                if (SubLinkList) {
                                    SubLinkList.classList.add("expand-menu");
                                }
                            }
                        }
                    });
                    let OpenLevel1 = document.querySelector(".expand-menu.menu--level-2");
                    let OpenLevel2 = document.querySelector(".expand-menu.menu--level-3");
                    let OpenLevel3 = document.querySelector(".expand-menu.menu--level-4");
                    if (OpenLevel1) {
                        OpenLevel1.style.setProperty("--BgHeight", OpenLevel1.clientHeight + "px");
                     
                        if (OpenLevel2) {
                            let ParentLevel1 = OpenLevel1.closest(".menu--level-2");
                            if (OpenLevel2.clientHeight > ParentLevel1.clientHeight) {
                                ParentLevel1.style.setProperty("--BgHeight", OpenLevel2.clientHeight + "px");
                            } else {
                                ParentLevel1.style.setProperty("--BgHeight", OpenLevel1.clientHeight + "px");
                            }
                            if (OpenLevel3) {
                                let ParentLevel1 = OpenLevel2.closest(".menu--level-2");
                                if (OpenLevel3.clientHeight > OpenLevel2.clientHeight && OpenLevel3.clientHeight > ParentLevel1.clientHeight) {
                                    ParentLevel1.style.setProperty("--BgHeight", OpenLevel3.clientHeight + "px");
                                } else {
                                    if (OpenLevel2.clientHeight > ParentLevel1.clientHeight) {
                                        ParentLevel1.style.setProperty("--BgHeight", OpenLevel2.clientHeight + "px");
                                    } else {
                                        ParentLevel1.style.setProperty("--BgHeight", OpenLevel1.clientHeight + "px");
                                    }
                                }
                            }
                        }
                    }
                    PrevTarget = Target;
                }
                prevTarget = evt.target;
            };
            const ExpandMenu = (elt) => {

                elt.dataset.menu_open = "false";
                elt.addEventListener("click", ApplyExpand);
                if (window.innerWidth >= 1100) {
                    elt.addEventListener(
                        "mouseover",
                        (evt) => {
                            let easeIn = 0;
                            timerOver = setInterval(() => {
                                easeIn++;
                                if (easeIn > 10) {
                                    clearInterval(timerOver);
                                    ApplyExpand(evt);
                                }
                            }, 10);
                        },
                        { passive: false }
                    );
                    elt.addEventListener("mouseleave", () => {
                        clearInterval(timerOver);
                    });
                }
            };
            // once("newCrpceMenu", ".menu-container-slider", context).forEach(MenuCrpce); //A
            // once("newCrpceMenu", "#primary-menu .menu-item > a, #primary-menu .menu-item > .menu__link--nolink", context).forEach(ExpandMenu);
            // once("newCrpceMenu", "#header", context).forEach((elt) => {
            //     elt.addEventListener("mouseleave", () => {
            //         CloseMenuDesktop();
            //     });
            // });

            // PLUS QUE CELUI LA A FAIRE // LE CLOSE
            // once("newCrpceMenu", ".menu-close", context).forEach((elt) => {
            //     elt.addEventListener("click", CloseMenu);
            // });
     
            MenuCrpce();
          
            var all_link = document.querySelectorAll('#primary-menu .menu-item-has-children > a');
            all_link.forEach(function (link_menu, index) {
             ExpandMenu(link_menu);
          });
            Header.addEventListener("mouseleave", CloseMenuDesktop);







  // /**********************************************************************/
  // /*************** GALLERIE HOME PAGE  ****************/
  // /**********************************************************************/
       

  var HomeTopGallery = new Swiper('.js-swiper-HomeGallery', {
      slidesPerView: 1,
      loop: true,
      speed: 1000,
      // allowTouchMove: false,
      // slideToClickedSlide: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },     
       pagination: {
        el: ".swiper-pagination",
         clickable: true
      },
    //watchSlidesProgress: true,
  });
    


  // /**********************************************************************/
  // /*************** GALLERIE FEATURE BESOIN  ****************/
  // /**********************************************************************/
       


  const swiperFeatureBesoins = new Swiper('.js-swiper-BesoinFeature', {
  // Optional parameters
  loop: true,
  centeredSlidesBounds: true,
  slidesPerView: 1.5,
  spaceBetween: 25,
  centeredSlides:true,

   breakpoints: {
     2400: { // a partir de 769
        spaceBetween: 70,
        slidesPerView: 4,
        centeredSlides:false
      },
    1900: { // a partir de 769
        spaceBetween: 70,
        slidesPerView: 3.3,
        centeredSlides:false
    },
    1025: { // a partir de 769
        spaceBetween: 40,
        slidesPerView: 3.3,
        centeredSlides:false
    },
    767: { // a partir de 769
        spaceBetween: 25,
        slidesPerView: 2.5,
        centeredSlides:false
    }
   },

  // Navigation arrows
  navigation: {
    nextEl: '.BPN-besoins .swiper-button-next',
    prevEl: '.BPN-besoins .swiper-button-prev',
  }
});

    // /**********************************************************************/
  // /*************** GALLERIE FEATURE SOLUTIONS  ****************/
  // /**********************************************************************/
       


  const swiperFeatureSolution = new Swiper('.js-swiper-SolutionFeature', {
  // Optional parameters
  loop: true,
  centeredSlidesBounds: true,
  slidesPerView: 1.5,
  spaceBetween: 25,
   centeredSlides:true,

   breakpoints: {
     2400: { // a partir de 769
        spaceBetween: 70,
        slidesPerView: 4,
        centeredSlides:false
      },
    1900: { // a partir de 769
        spaceBetween: 70,
        slidesPerView: 3.3,
        centeredSlides:false
    },
    1025: { // a partir de 769
        spaceBetween: 40,
        slidesPerView: 3.3,
        centeredSlides:false
    },
    767: { // a partir de 769
        spaceBetween: 25,
        slidesPerView: 2.5,
        centeredSlides:false
    }
   },


  // Navigation arrows
  navigation: {
    nextEl: '.BPN-solutions .swiper-button-next',
    prevEl: '.BPN-solutions .swiper-button-prev',
  }
});

   // /**********************************************************************/
  // /*************** SLIDER LAST POST  ****************/
  // /**********************************************************************/
       


  const swiperLastPost = new Swiper('.js-swiper-LastPost', {
  // Optional parameters
  loop: true,
  centeredSlidesBounds: true,
  slidesPerView: 1,
  spaceBetween: 24,
  breakpoints: {
    1025: { // a partir de 769
        spaceBetween: 24,
        slidesPerView: 3,
    },
    500: { // a partir de 769
        spaceBetween: 25,
        slidesPerView: 2,
    }
   },

  // Navigation arrows
  navigation: {
    nextEl: '.LastPBtn .swiper-button-next',
    prevEl: '.LastPBtn .swiper-button-prev',
  }
});



   // /**********************************************************************/
  // /*************** SLIDER DIAPO LOGO  ****************/
  // /**********************************************************************/
       


  const SwiperDiapoLogo = new Swiper('.js-DiapoLogo', {
  // Optional parameters
  loop: true,
  centeredSlidesBounds: true,
  slidesPerView: 2,
  spaceBetween: 24,
  breakpoints: {
    1025: { // a partir de 769
        spaceBetween: 100,
        slidesPerView: 4,
    },
    500: { // a partir de 769
        spaceBetween: 75,
        slidesPerView: 3,
    }
   },

  // Navigation arrows
  navigation: {
    nextEl: '.LastPBtn .swiper-button-next',
    prevEl: '.LastPBtn .swiper-button-prev',
  }
});




  

  // FORM CONTACT LABEL ///

  $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });




  /*********************************/
/**  PÄGE FAQ **/
/*********************************/

   // .not( "#content_s_1" )
   $('.accordion-section-content:not(.first)').hide();
   $('.FAQ-Item.first').addClass('active');

   //$('.accordion-section-content').hide();
    // ACCORDEON SECTION 
    function close_accordion_section() {
        $('.accordeon-page .accordion-section-title').removeClass('active');
        $('.accordeon-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');
      
         $('.accordeon-page .FAQ-Item.active .FAQ-Item-Content').not(currentAttrValue).slideUp(300);
         $('.accordeon-page .FAQ-Item.active .FAQ-Item-Content').not(currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            // Open up the hidden content panel
            $('.accordeon-page ' + currentAttrValue).slideDown(300).addClass('open'); 
        }
 
        e.preventDefault();
    });
    // FIN ACCORDEON //
    ////////////////////
    




  // /**********************************************************************/
  // /*************** GALLERIE TOUTE LES PAGES / DAMIER  ****************/
  // /**********************************************************************/
       

  var GalleryDamier = new Swiper('.js-swiper-DamierGallery', {
      slidesPerView: 1,
      loop: true,
      speed: 1000,
      // allowTouchMove: false,
      // slideToClickedSlide: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },     
       pagination: {
        el: ".swiper-pagination",
         clickable: true
      },
    //watchSlidesProgress: true,
  });
    
    



      // /**********************************************************************/
  // /*************** FORMULAIRE DE RECHERCHE  ****************/
  // /**********************************************************************/
       

    $( ".trigger-search, .go_recherche" ).click(function() {
        $(this).toggleClass('active');
        $('body').toggleClass('drawer-search-open');
    });

    $( "#close_top_form" ).click(function() {
        $('body').toggleClass('drawer-search-open');
    });




      /******************************************/
    /********** LIGHTBOX VIDEO HOME PAGE // NEW VERSION *************/
  /******************************************/

    $('.btn-open-lb').featherlight({
        type : 'html',
        persist:'shared',
    closeIcon: '<i class="icon-close">'
    });
    
 //  var popup_already_display = sessionStorage.getItem('popState');
 // // popup_already_display = 'test';

 //  if(popup_already_display != 'shown'){
    
 //    if ( $( ".lightbox_popup_event--link" ).length ) {
 //      $('.lightbox_popup_event--link').featherlight({
 //        closeIcon: '<i class="icon-close"></i>',
 //        loading: 'Chargement...', 
 //        afterOpen: function(event){
 //           sessionStorage.setItem('popState','shown');
 //           // console.log(this.lightbox); // this contains all related elements
 //            $('.featherlight-content').addClass('featherlight_special_event');
 //          }
        
 //      }).click();
 //    }
 //  }

    $('.stickyCall .btn-degrade').on( "click", function(evt) {
          evt.preventDefault();
          $( "#amesla-reservation-widget-button-id" ).trigger( "click" );
    } );

}); 



